import { FormControl, FormGroup, Validators } from '@angular/forms';

export function createGarantieCalculatorForm(): FormGroup<GarantieCalculatorFormModel> {
  return new FormGroup<GarantieCalculatorFormModel>({
    isPremiumSchutz: new FormControl<null | boolean>(null, [Validators.required])
  });
}

export interface GarantieCalculatorFormModel {
  isPremiumSchutz: FormControl<null | boolean>;
}
